import { h, Fragment } from "preact"
import { useState } from "preact/hooks"
import Avatar from "@mui/material/Avatar"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem/MenuItem"
import Divider from "@mui/material/Divider/Divider"
import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon"
import Icon from "@mui/material/Icon/Icon"
import IconButton from "@mui/material/IconButton/IconButton"
import { v4 as uuid } from "uuid"

export default function ProfileMenu(props: {
  profiles: string[]
  activeProfile: string
  setProfileID: (id: string) => any
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  // @ts-expect-error I don't know where to find this "MouseEventHandler" type.
  const handleClick = (event: MouseEventHandler<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Avatar src={roboHashURL(props.activeProfile)} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            "overflow": "visible",
            "filter": "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            "mt": 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.profiles.map((profile: string) => (
          <MenuItem onClick={() => props.setProfileID(profile)}>
            <Avatar src={roboHashURL(profile)} /> {profile}
          </MenuItem>
        ))}
        <Divider />
        <MenuItem onClick={() => props.setProfileID(uuid())}>
          <ListItemIcon>
            <Icon children="person_add" />
          </ListItemIcon>
          Add another profile
        </MenuItem>
      </Menu>
    </>
  )
}

function roboHashURL(id: string): string {
  return `https://robohash.org/${id}.png?bgset=bg1`
}
